/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, IWrapHTTPConfig } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClientForm } from '../models/client-form';
import { ClientPassForm } from '../models/client-pass-form';
import { ClientSearchForm } from '../models/client-search-form';
import { EmptyResponse } from '../models/empty-response';
import { ResponseClientItemDto } from '../models/response-client-item-dto';
import { ResponsePageableListDtoClientListDto } from '../models/response-pageable-list-dto-client-list-dto';

@Injectable({
  providedIn: 'root',
})
export class AdminClientsApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getClient
   */
  static readonly GetClientPath = '/api/v1/admin/clients/{clientId}';

  /**
   * Get client
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClient()` instead.
   *
   * This method doesn't expect any request body.
   */
  private getClient$Response(params: {
    clientId: number;
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponseClientItemDto>> {

    const rb = new RequestBuilder(this.rootUrl, AdminClientsApiService.GetClientPath, 'get');
    if (params) {
      rb.path('clientId', params.clientId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponseClientItemDto>;
      })
    );
  }

  /**
   * Get client
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getClient$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClient(params: {
    clientId: number;
  }, config?: IWrapHTTPConfig
): Observable<ResponseClientItemDto> {

    return this.wrapHTTPQuery(this.getClient$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponseClientItemDto>) => r.body as ResponseClientItemDto)
    ), config);
  }

  /**
   * Path part for operation updateClient
   */
  static readonly UpdateClientPath = '/api/v1/admin/clients/{clientId}';

  /**
   * Update client
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateClient()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  private updateClient$Response(params: {
    clientId: number;
    body: ClientForm
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponseClientItemDto>> {

    const rb = new RequestBuilder(this.rootUrl, AdminClientsApiService.UpdateClientPath, 'put');
    if (params) {
      rb.path('clientId', params.clientId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponseClientItemDto>;
      })
    );
  }

  /**
   * Update client
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateClient$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateClient(params: {
    clientId: number;
    body: ClientForm
  }, config?: IWrapHTTPConfig
): Observable<ResponseClientItemDto> {

    return this.wrapHTTPQuery(this.updateClient$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponseClientItemDto>) => r.body as ResponseClientItemDto)
    ), config);
  }

  /**
   * Path part for operation deleteClient
   */
  static readonly DeleteClientPath = '/api/v1/admin/clients/{clientId}';

  /**
   * Delete client
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteClient()` instead.
   *
   * This method doesn't expect any request body.
   */
  private deleteClient$Response(params: {
    clientId: number;
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<EmptyResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdminClientsApiService.DeleteClientPath, 'delete');
    if (params) {
      rb.path('clientId', params.clientId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmptyResponse>;
      })
    );
  }

  /**
   * Delete client
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteClient$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteClient(params: {
    clientId: number;
  }, config?: IWrapHTTPConfig
): Observable<EmptyResponse> {

    return this.wrapHTTPQuery(this.deleteClient$Response(params, config).pipe(
      map((r: StrictHttpResponse<EmptyResponse>) => r.body as EmptyResponse)
    ), config);
  }

  /**
   * Path part for operation searchClients
   */
  static readonly SearchClientsPath = '/api/v1/admin/clients/search';

  /**
   * Search clients
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchClients()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  private searchClients$Response(params: {
    body: ClientSearchForm
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponsePageableListDtoClientListDto>> {

    const rb = new RequestBuilder(this.rootUrl, AdminClientsApiService.SearchClientsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponsePageableListDtoClientListDto>;
      })
    );
  }

  /**
   * Search clients
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `searchClients$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchClients(params: {
    body: ClientSearchForm
  }, config?: IWrapHTTPConfig
): Observable<ResponsePageableListDtoClientListDto> {

    return this.wrapHTTPQuery(this.searchClients$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponsePageableListDtoClientListDto>) => r.body as ResponsePageableListDtoClientListDto)
    ), config);
  }

  /**
   * Path part for operation passClient
   */
  static readonly PassClientPath = '/api/v1/admin/clients/pass';

  /**
   * Pass client
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `passClient()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  private passClient$Response(params: {
    body: ClientPassForm
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<EmptyResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdminClientsApiService.PassClientPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmptyResponse>;
      })
    );
  }

  /**
   * Pass client
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `passClient$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  passClient(params: {
    body: ClientPassForm
  }, config?: IWrapHTTPConfig
): Observable<EmptyResponse> {

    return this.wrapHTTPQuery(this.passClient$Response(params, config).pipe(
      map((r: StrictHttpResponse<EmptyResponse>) => r.body as EmptyResponse)
    ), config);
  }

  /**
   * Path part for operation createClient
   */
  static readonly CreateClientPath = '/api/v1/admin/clients';

  /**
   * Create client
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createClient()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  private createClient$Response(params: {
    body: ClientForm
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponseClientItemDto>> {

    const rb = new RequestBuilder(this.rootUrl, AdminClientsApiService.CreateClientPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponseClientItemDto>;
      })
    );
  }

  /**
   * Create client
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createClient$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createClient(params: {
    body: ClientForm
  }, config?: IWrapHTTPConfig
): Observable<ResponseClientItemDto> {

    return this.wrapHTTPQuery(this.createClient$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponseClientItemDto>) => r.body as ResponseClientItemDto)
    ), config);
  }

}
